import React from 'react';

const fishSchool =
  'https://santaplaya-bucket.s3.amazonaws.com/basic_fish_school.webp';

// Sodas items
const sodas = [
  { name: 'Flavors: Horchata, Cucumber/Lime, Jamaica', price: '$7' },
  { name: 'Coca-Cola', price: '$6.50' },
  { name: 'Diet Coke', price: '$5' },
  { name: 'Sprite', price: '$5.50' },
  { name: 'Fanta', price: '$5.50' },
  { name: 'Mineral Water', price: '$5.50' },
];

// Alcohol items
const alcohol = [
  {
    name: 'On Tap',
    price: '$8',
    description: 'Any beer on tap.',
  },
  {
    name: 'Pitcher',
    price: '$30',
    description: 'Any beer on tap.',
  },
  {
    name: 'Bottles',
    price: '$7',
    description:
      'Beers: Modelo Especial, Pacifico, Modelo Negro, Buenaveza, Fremont, MadeWest, Corona, White Claw',
  },
  {
    name: 'Bucket',
    price: '$44',
    description: 'Any 6 bottled alcoholic drinks.',
  },
  {
    name: 'Micheladas',
    price: '$12',
    description: '',
  },
];

const DrinksSection: React.FC = () => {
  return (
    <section className="relative bg-maroon py-12 px-4 lg:px-24">
      {/* Top Content: Left half on desktop, full width on mobile */}
      <div className="relative z-10">
        {/* For desktop, restrict to left half; for mobile, full width */}
        <div className="w-full lg:w-1/2 text-center ">
          <h2 className="font-charles text-white text-4xl md:text-5xl py-32 mb-6">
            BEBIDAS | DRINKS
          </h2>
          <div className="space-y-8">
            <div>
              <h3 className="font-charles text-white text-2xl mb-2">
                Jarritos
              </h3>
              <p className="font-prosto text-basic text-lg">
                Flavors: Mandarin, Tamarindo, Fruit Punch, Guava, Pineapple
              </p>
              <p className="font-charles text-white text-xl md:text-2xl mt-2">
                $5.50
              </p>
            </div>
            <div>
              <h3 className="font-charles text-white text-2xl mb-2">
                Aguas Frescas
              </h3>
              <p className="font-prosto text-basic text-lg">
                Flavors: Horchata, Cucumber/Lime, Jamaica
              </p>
              <p className="font-charles text-white text-xl md:text-2xl mt-2">
                $7
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Right Image: fishSchool (only on desktop) */}
      <div className="absolute right-0 -top-8 h-full">
        <img src={fishSchool} alt="Fish School" className="w-[55vw]" />
      </div>

      {/* Two-column layout for SODAS & ALCOHOL */}
      <div className="max-w-6xl mx-auto mt-12 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left Column: SODAS */}
          <div className="pr-4 border-r border-white">
            <h3 className="font-charles text-white text-3xl mb-4 text-center lg:text-left">
              SODAS
            </h3>
            <ul className="space-y-4">
              {sodas.map((item, idx) => (
                <li
                  key={idx}
                  className="flex justify-between text-white font-prosto text-lg"
                >
                  <span>{item.name}</span>
                  <span className="font-bold">{item.price}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Column: ALCOHOL */}
          <div className="pl-4">
            <h3 className="font-charles text-white text-3xl mb-4 text-center lg:text-left">
              ALCOHOL
            </h3>
            <ul className="space-y-4">
              {alcohol.map((item, idx) => (
                <li key={idx} className="text-white font-prosto text-lg">
                  <div className="flex justify-between">
                    <span>{item.name}</span>
                    <span className="font-bold">{item.price}</span>
                  </div>
                  {item.description && item.description.length > 0 && (
                    <p className="text-sm text-white/80 mt-1">
                      {item.description}
                    </p>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DrinksSection;
